import DocumentsApi from '@app/api/public/DocumentsApi';
import { useQuery } from 'react-query';
import { fileKeys } from '../../queryKeys';

const useGetS3File = (s3Name: string) => {
    return useQuery([...fileKeys.detail(s3Name)], () => DocumentsApi.getS3FileUrl(s3Name));
};

export default useGetS3File;
